import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const StopIcon = ({ color = '#f1524b', size = '20', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill={color}
      d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm6.2 11.3H3.8V8.7h12.3v2.6z"
    />
  </svg>
);

StopIcon.propTypes = propTypes;

export default StopIcon;
